<template>
  <div>
    <a-form :form="form">
      <div class="title">{{ $t('admin.content.lab.network.title') }}</div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.content.lab.network.fields.title.label')" :colon="false">
          <div class="content tagContent">
            <div class="tag">
              <div class="tagList" :class="{select: item.id === selectId}" v-for="item of tags" :key="item.id" @click="selectTag(item)">{{ item.title }}</div>
            </div>
            <div class="tagEdit" @click="tagManageShow = true">
              <img src="~@/assets/icons/tag_add.png" alt="">
              <span>{{ $t('admin.content.lab.network.tagManage.edit') }}</span>
            </div>
          </div>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.content.lab.network.fields.content.label')" :colon="false">
          <div v-decorator="['content', { rules: [{ required: true, message: $t('admin.content.lab.network.fields.content.required') }] }]">
            <Editor v-model="contentValue" ref="editor"></Editor>
          </div>
        </a-form-item>
      </div>
    </a-form>
    <a-modal :title="$t('admin.content.lab.network.tagManage.title')" :visible="tagManageShow" @cancel="tagManageShow = false">
      <div>
        <div class="tagManagelist" v-for="item of tags" :key="item.id">
          <a-input v-model="item.title" :maxLength="8" :placeholder="$t('admin.content.lab.network.tagManage.placeholder')" />
          <img src="@/assets/icons/tag_delete.png" @click="tagDelete(item)" alt="">
        </div>
        <img class="tagAdd" @click="tagAdd" src="@/assets/icons/lab_tag_add.png" alt="">
      </div>
      <template slot="footer">
        <a-button key="submit" type="primary" @click="submitTagManage">
          {{ $t('admin.content.lab.network.tagManage.complete') }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import Upload from '@/components/upload/index.vue'
import Editor from '@/components/Editor/tinymce.vue'

import {
  labDetail
} from '@/api/admin'

export default {
  components: {
    Editor,
    Upload
  },
  data() {
    return {
      id: undefined,
      tags: [
        { id: 1, title: this.$t('admin.content.lab.network.tagManage.defaultTag'), content: '' }
      ],
      selectId: '',
      contentValue: '',
      stateList: [
        { id: 1, name: this.$t('admin.content.lab.network.stateList.enable') },
        { id: 2, name: this.$t('admin.content.lab.network.stateList.disable') }
      ],
      tagManageShow: false,
      form: this.$form.createForm(this)
    }
  },
  watch: {
    contentValue: {
      handler(val) {
        this.form.setFieldsValue({
          content: val
        })
        this.tags = this.tags.map(item => {
          if (item.id === this.selectId) {
            item.content = val
          }
          return item
        })
      }
    }
  },
  methods: {
    tagDelete(item) {
      if (this.tags.length === 1) {
        this.$message.warning(this.$t('admin.content.lab.network.messages.minTags'))
        return
      }
      if (this.selectId === item.id) {
        this.$message.warning(this.$t('admin.content.lab.network.messages.cannotDelete'))
        return
      }
      this.tags = this.tags.filter(tag => tag.id !== item.id)
    },
    submitTagManage() {
      if (this.tags.some(item => !item.title)) {
        this.$message.warning(this.$t('admin.content.lab.network.messages.fillAll'))
        return
      }
      this.tagManageShow = false
    },
    tagAdd() {
      if (this.tags.length >= 6) {
        this.$message.warning(this.$t('admin.content.lab.network.messages.maxTags'))
        return
      }
      if (this.tags.some(item => !item.title)) {
        this.$message.warning(this.$t('admin.content.lab.network.messages.fillAll'))
        return
      }
      this.tags.push({
        id: this.tags.length + 1,
        title: '',
        content: ''
      })
    },
    selectTag(item) {
      this.selectId = item.id
      this.contentValue = item.content
    },
    handleSubmit() {
      let isSuccess = false
      this.form.validateFields((err, values) => {
        if (!err) {
          isSuccess = true
        }
      })
      return isSuccess
    },
    init() {
      this.selectTag(this.tags[0])
      this.$refs.editor.setTinymceContent()
    }
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.tagManagelist{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-bottom: 12px;
  img{
    width: 20px;
    cursor: pointer;
    display: none;
  }
  &:hover > img{
    display: block;
  }
  /deep/ .ant-input{
    width: 445px;
    text-align: center;
    height: 40px;
    &:hover{
      color: #F27529;
    }
  }
}
.tagAdd{
  width: 40px;
  cursor: pointer;
}
h4{
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin{
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo{
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down{
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix{
  right: 12px;
  img{
    width: 23px;
    cursor: pointer;
  }
}
/deep/.ant-form{
  .title{
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #EDEDED;
    &::before{
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6B738C;
    }
  }
  .list{
    display: flex;
    width: 100%;
    .ant-form-item-label{
      // position: absolute;
      // top: 0;
      // left: 0;
      // width: 100px;
      // text-align: right;
    }
    .ant-form-item-label label{
      color: #000000;
    }
    .ant-form-item{
      width: 100%;
      // padding-left: 100px;
      position: relative;
      padding-right: 10px;
    }
    .ant-input-affix-wrapper .ant-input-suffix{
      position: absolute;
      img{
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div{
      position: relative;
      .ant-calendar-picker-input{
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #D8DCE0;
      }

    }
    .ant-input,
    .ant-select{
      border-radius: 20px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select{
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 20px;
    }
    .content .textarea{
      background: #FCFCFC;
      border-radius: 4px;
      border: 1px solid #D8DCE0;
    }
    .tagContent{
      display: flex;
      width: 100%;
      background: #FCFCFC;
      border-radius: 4px;
      border: 1px solid #F4F7FA;
      .tag{
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0 10px;
        .tagList{
          height: 35px;
          background: #FFFFFF;
          border-radius: 4px;
          border: 1px solid #D8DCE0;
          padding: 0 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          cursor: pointer;
        }
        .select{
          color: #F27529;
          border-color: #F27529;
        }
      }
      .tagEdit{
        display: flex;
        align-items: center;
        width: 90px;
        cursor: pointer;
        img{
          width: 22px;
          height: 22px;
          margin-right: 7px;
        }
        span{
          font-size: 14px;
          font-weight: 400;
          color: #000000;
          line-height: 20px;
        }
      }
    }
    .ant-input-wrapper.ant-input-group{
      .ant-input{
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon{
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5E7A92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .submit-button{
    width: 100%;
    // padding-left: 500px;
    text-align: center;
  }
}
</style>
